export const GET_CREDIT_REQUEST = 'GET_CREDIT_REQUEST';
export const GET_CREDIT_SUCCESS = 'GET_CREDIT_SUCCESS';
export const GET_CREDIT_FAILURE = 'GET_CREDIT_FAILURE';
export const ADD_CREDIT = 'ADD_CREDIT';
export const ADD_CREDIT_FAILURE = 'ADD_CREDIT_FAILURE';
export const WITHDRAW_CREDIT = 'WITHDRAW_CREDIT';
export const WITHDRAW_CREDIT_FAILURE = 'WITHDRAW_CREDIT_FAILURE';
export const CLEAR_CREDIT_ERROR = 'CLEAR_CREDIT_ERROR';